var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SubmitButton',{attrs:{"loading":_vm.loading,"icon":"fa fa-sync","text":_vm.$t('ui.sync'),"type":"button","variant":"danger","size":"sm"},on:{"click":function($event){return _vm.sync()}}})}
var staticRenderFns = []

export { render, staticRenderFns }